<template>
  <section class="hero is-fullheight method-page">
    <PmNavbar />
    <div class="hero-body is-align-items-flex-start">
      <div class="container">
        <div class="columns is-multiline py-5 white-bg">
          <div class="column is-10 is-offset-1">
            <h3
              class="has-text-centered cstm-font-color font-secondary cstm-underline pt-5 pb-5"
            >
              2/4 Valitse lautasen materiaali
            </h3>
            <p class="has-text-centered cstm-font-color font-18">
              Valitse lautasen materiaali ja mahdollinen painatus. Huom!
              Painatus saatavilla vain lautasen reunoille. Laatikossa on 500 kpl
              ja toimitukset täysinä laatikollisina.
            </p>
          </div>
        </div>

        <div class="columns is-multiline white-bg mt-5 pb-5">
          <div class="column is-offset-1 is-10 has-text-centered pb-5">
            <p class="has-text-centered font-secondary font-20 py-5">
              Valittu tuote: {{ this.product?.name }}
            </p>

            <p class="has-text-left font-secondary font-18 mt-3">
              Materiaalit ja hinnat
            </p>
            <template v-if="this.product?.name == 'Lautaset 190 x 190 mm'">
              <label class="radio font-18 is-flex is-align-items-center">
                <input
                  class="cstm-radio-input mr-1"
                  type="radio"
                  v-model="plateMaterial"
                  :value="'OPT_1'"
                />
                Valkoinen taivekartonki 50,00 € /ltk (0,10 €/kpl)
              </label>
              <label class="radio font-18 is-flex is-align-items-center">
                <input
                  class="cstm-radio-input mr-1"
                  type="radio"
                  v-model="plateMaterial"
                  :value="'OPT_2'"
                />
                Keltainen kartonki 50,00 € /ltk (0,10 €/kpl)
              </label>
              <label
                class="radio font-18 is-flex is-align-items-center"
                v-if="this.product?.name == 'Lautaset 190 x 190 mm'"
              >
                <input
                  class="cstm-radio-input mr-1"
                  type="radio"
                  v-model="plateMaterial"
                  :value="'OPT_3'"
                />
                Valkoinen barrier kartonki 55,00 € /ltk (0,11 €/kpl)
              </label>

              <p class="has-text-left font-secondary font-18 mt-5">
                Oma painatus
              </p>
              <p class="has-text-left">
                Omalla painatuksella min 2500 kpl 75,00 € /ltk (0,15 €/kpl)
              </p>
              <p class="has-text-left is-underlined">
                <a @click="openContactFormModal">Lautaset omalla painatuksella, ota yhteyttä!</a>
              </p>
            </template>
            <template v-if="this.product?.name == 'Lautaset 239 x 239 mm'">
              <label class="radio font-18 is-flex is-align-items-center">
                <input
                  class="cstm-radio-input mr-1"
                  type="radio"
                  v-model="plateMaterial"
                  :value="'OPT_1'"
                />
                Valkoinen taivekartonki 60,00 € /ltk (0,12 €/kpl)
              </label>
              <label class="radio font-18 is-flex is-align-items-center">
                <input
                  class="cstm-radio-input mr-1"
                  type="radio"
                  v-model="plateMaterial"
                  :value="'OPT_2'"
                />
                Keltainen kartonki 60,00 € /ltk (0,12 €/kpl)
              </label>
            </template>
          </div>

          <div class="column is-12 has-text-centered">
            <button class="button pm-button" @click="goToCart">
              Ostoskoriin
            </button>
          </div>
        </div>
      </div>
    </div>
    <ContactFormModal ref="contactFormModal" />
    <PmFooter />
  </section>
</template>

<script>
import PmNavbar from "../components/PmNavbar";
import PmFooter from "../components/PmFooter";
import addProductMixin from "@/mixins/addProduct";
import { mapActions, mapMutations } from "vuex";
import cartMixin from "@/mixins/cartMixin";
import ContactFormModal from '../modals/ContactFormModal'

export default {
  name: "ChoosePlateMaterialPage",
  mixins: [addProductMixin, cartMixin],
  components: {
    PmNavbar,
    PmFooter,
    ContactFormModal,
  },
  data() {
    return {
      product: null,
      plateMaterial: "OPT_1",
    };
  },
  methods: {
    ...mapMutations(["setSpinnerState"]),
    ...mapActions({
      updateItem: "updateItem",
      getOrder: "getOrder",
    }),
    goToCart() {
      // Create plate with material option
      this.setSpinnerState(true);
      let order = this.getOrderData();
      this.updateItem({
        id: this.$route.params.item,
        material: this.plateMaterial,
        draft: false,
      }).then(() => {
        // Refresh order state
        this.getOrder().then(() => {
          this.setSpinnerState(false);
          this.$router.push({
            name: "Cart",
            params: {
              uuid: order.id,
            },
          });
        });
      });
    },
    openContactFormModal() {
      this.$refs.contactFormModal.showModal()
    }
  },
  mounted() {
    this.product = this.$store.getters.getProductById(
      this.$route.params.productId
    );
    this.plateMaterial = this.selectedProduct.material;
  },
  computed: {},
};
</script>

<style scoped lang="scss">
@use "../assets/sass/variables" as *;

.method-page {
  .cstm-font-color {
    color: $font-color-primary;
  }
  .white-bg {
    background-color: #ffffff;
  }
}
</style>
